import React from 'react';
export function Footer() {
  return <footer className="bg-[#2D2D2D] text-white py-12 border-t border-white/10" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-49">
        <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-50">
          <h4 className="font-serif text-xl font-bold mb-2" data-id="element-51">
            DESERT HILLS ESTATE
          </h4>
          <p className="text-gray-400 text-sm" data-id="element-52">
            A lifestyle property like no other.
          </p>
        </div>

        <div className="flex space-x-8 text-sm text-gray-400" data-id="element-53">
          <a href="#" className="hover:text-white transition-colors" data-id="element-54">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-55">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-56">
            Contact Agent
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 pt-8 border-t border-white/10 text-center text-xs text-gray-500" data-id="element-57">
        &copy; {new Date().getFullYear()} Luxury Desert Properties. All rights
        reserved.
      </div>
    </footer>;
}